import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import AppService from 'Services/AppService';

import { Form, Button, InputGroup, Breadcrumb } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
// import { useForm } from 'react-hook-form';

import * as yup from 'yup';
import { Formik } from 'formik';

const schema = yup.object({
    name: yup.string().required(),
    description: yup.string().required(),
    appType: yup.number().required(),
    url: yup.string().nullable(),
    deepLink: yup.string().nullable(),
    image: yup.mixed(),
    listed: yup.boolean().required(),
    noAuth: yup.boolean().required(),
});

const Apps = (props) => {
    const history = useHistory();
    const {
        match: { params },
    } = props;
    const [app, setApp] = useState(null);
    // const [https, setHttps] = useState('https');

    // const toggleHttps = () => {
    //     if (https === 'https') {
    //         setHttps('http');
    //     } else {
    //         setHttps('https');
    //     }
    // };

    useEffect(() => {
        if (params.appId) {
            AppService.getAppById(params.appId)
                .then((result) => {
                    if (result.status === 200) {
                        // if (result.data.url) {
                        //     const parsed = result.data.url.split('://');
                        //     setHttps(parsed[0]);
                        //     result.data.url = parsed[1];
                        // }

                        setApp(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params.appId]);

    // const { register, handleSubmit, errors, watch } = useForm();

    // const appType = watch('type', 1);
    // const form = useRef(null);

    const submitForm = (data) => {
        // console.log('data', data);
        // console.log(form.current);
        const formData = new FormData();
        formData.append('key', 'value');
        for (const [key, value] of Object.entries(data)) {
            // console.log(`${key}: ${value}`);
            formData.append(key, value);
        }
        //
        // const formDataX = new FormData();
        // formDataX.append('a', JSON.stringify({ a: 1, b: 2, c: 3 }));
        // formDataX.append('b', '2');
        // formDataX.append('c', '3');
        // formDataX.append('xxx', data['image']);
        // for (const [key, value] of formDataX.entries()) {
        //     console.log(`${key}: ${value}`);
        // }
        // return;
        //
        // const domain = https + '://' + formData.get('url');
        // formData.set('url', domain);

        // console.log(formData);

        AppService.saveApp(formData, params.appId)
            .then((result) => {
                if (result.status === 200) {
                    history.push('/admin/app/index');
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <>
            <Breadcrumb className="mt-3">
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/' }}>
                    Home
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin' }}>
                    Admin
                </Breadcrumb.Item>
                <Breadcrumb.Item linkAs={Link} linkProps={{ to: '/admin/app/index' }}>
                    Apps
                </Breadcrumb.Item>
                <Breadcrumb.Item active>{params.appId ? 'Edit App' : 'Create New App'}</Breadcrumb.Item>
            </Breadcrumb>
            <div className="row py-3">
                <div className="col text-center">
                    <h2 className="mb-0">{params.appId ? 'Edit App' : 'Create New App'}</h2>
                    <i style={{ fontSize: '8pt', fontStyle: 'unset' }}>{params.appId}</i>
                </div>
            </div>
            <div className="row">
                <div className="col-md-3"></div>
                <div className="col-md-6">
                    <Formik
                        validationSchema={schema}
                        onSubmit={(values) => submitForm(values)}
                        enableReinitialize={true}
                        initialValues={{
                            name: app ? app.name : '',
                            description: app ? app.description : '',
                            appType: app ? app.appType : 0,
                            url: app ? app.url : '',
                            deepLink: app ? app.deepLink : '',
                            image: app ? app.image : '',
                            listed: app ? app.listed : true,
                            noAuth: app ? app.noAuth : true,
                        }}
                    >
                        {({ handleSubmit, handleChange, values, errors }) => (
                            <Form noValidate onSubmit={handleSubmit}>
                                <Form.Group controlId="formBasicEmail">
                                    <Form.Label>Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="name"
                                        name="name"
                                        value={values.name}
                                        onChange={handleChange}
                                        isInvalid={!!errors.name}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.name}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={2}
                                        name="description"
                                        value={values.description}
                                        onChange={handleChange}
                                        isInvalid={!!errors.description}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.description}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox3">
                                    <Form.Check
                                        type="checkbox"
                                        label="Home Listing"
                                        name="listed"
                                        checked={values.listed}
                                        onChange={handleChange}
                                        isInvalid={!!errors.listed}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.listed}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="formBasicCheckbox3noAuth">
                                    <Form.Check
                                        type="checkbox"
                                        label="Ignore CLIAM Auth"
                                        name="noAuth"
                                        checked={values.noAuth}
                                        onChange={handleChange}
                                        isInvalid={!!errors.noAuth}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.noAuth}</Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group controlId="exampleForm.ControlTextarea99">
                                    <Form.Label>Type</Form.Label>
                                    <Form.Control
                                        as="select"
                                        name="appType"
                                        value={values.appType}
                                        onChange={handleChange}
                                        isInvalid={!!errors.appType}
                                    >
                                        <option value={0}>Web</option>
                                        <option value={1}>Desktop</option>
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">{errors.appType}</Form.Control.Feedback>
                                </Form.Group>
                                {parseInt(values.appType) === 0 ? (
                                    <Form.Group controlId="Url">
                                        <Form.Label>Url</Form.Label>
                                        {/* <InputGroup className="mb-2"> */}
                                        {/* <InputGroup.Prepend>
                                            <InputGroup.Text onClick={toggleHttps}>{https}://</InputGroup.Text>
                                        </InputGroup.Prepend> */}
                                        <Form.Control
                                            type="text"
                                            placeholder="Url"
                                            name="url"
                                            value={values.url}
                                            onChange={handleChange}
                                            isInvalid={!!errors.url}
                                        />
                                        {/* </InputGroup>
                                        <Form.Control.Feedback type="invalid">{errors.url}</Form.Control.Feedback> */}
                                    </Form.Group>
                                ) : (
                                    <Form.Group controlId="deepLink">
                                        <Form.Label>DeepLink</Form.Label>
                                        <InputGroup className="mb-2">
                                            <Form.Control
                                                type="text"
                                                placeholder="DeepLink"
                                                name="deepLink"
                                                value={values.deepLink}
                                                onChange={handleChange}
                                                isInvalid={!!errors.deepLink}
                                            />
                                            {/* <InputGroup.Append>
                                                <InputGroup.Text>://</InputGroup.Text>
                                            </InputGroup.Append> */}
                                        </InputGroup>
                                        <Form.Control.Feedback type="invalid">{errors.deepLink}</Form.Control.Feedback>
                                    </Form.Group>
                                )}
                                <Form.Group controlId="image">
                                    <Form.Label>Logo</Form.Label>
                                    <Form.File
                                        id="custom-file"
                                        label="Custom file input"
                                        custom
                                        name="image"
                                        value={values.image}
                                        onChange={handleChange}
                                        isInvalid={!!errors.image}
                                    />
                                    <Form.Control.Feedback type="invalid">{errors.image}</Form.Control.Feedback>
                                </Form.Group>
                                {/* {console.log(errors)} */}
                                <Button variant="primary" type="submit" block>
                                    Submit
                                </Button>
                            </Form>
                        )}
                    </Formik>
                    {/* {errors.exampleRequired && <span>This field is required</span>}

                    <Form ref={form} onSubmit={handleSubmit(onSubmit)}>
                        <Form.Group controlId="name">
                            <Form.Label>Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="name"
                                name="name"
                                defaultValue={app ? app.name : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="description">
                            <Form.Label>Description</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={2}
                                name="description"
                                defaultValue={app ? app.description : ''}
                                ref={register({ required: true })}
                            />
                        </Form.Group>
                        <Form.Group controlId="type">
                            <Form.Label>Type</Form.Label>
                            <Form.Control as="select" name="type" ref={register({ required: true })}>
                                <option value="1">Web</option>
                                <option value="0">Desktop</option>
                            </Form.Control>
                        </Form.Group>
                        {appType === 1 ? (
                            <Form.Group controlId="Url">
                                <Form.Label>Url</Form.Label>
                                <InputGroup className="mb-2">
                                    <InputGroup.Prepend>
                                        <InputGroup.Text onClick={toggleHttps}>{https}://</InputGroup.Text>
                                    </InputGroup.Prepend>
                                    <Form.Control
                                        type="text"
                                        placeholder="Url"
                                        name="url"
                                        defaultValue={app ? app.url : ''}
                                        ref={register}
                                    />
                                </InputGroup>
                            </Form.Group>
                        ) : (
                            <Form.Group controlId="deepLink">
                                <Form.Label>DeepLink</Form.Label>
                                <InputGroup className="mb-2">
                                    <Form.Control
                                        type="text"
                                        placeholder="DeepLink"
                                        name="deepLink"
                                        defaultValue={app ? app.deepLink : ''}
                                        ref={register}
                                    />
                                    <InputGroup.Append>
                                        <InputGroup.Text>://</InputGroup.Text>
                                    </InputGroup.Append>
                                </InputGroup>
                            </Form.Group>
                        )}
                        <Form.Group controlId="image">
                            <Form.Label>Logo</Form.Label>
                            <Form.File id="custom-file" label="Custom file input" custom name="image" ref={register} />
                        </Form.Group>
                        <Button variant="primary" type="submit" block>
                            Submit
                        </Button>
                    </Form> */}
                </div>
                <div className="col-md-3"></div>
            </div>
        </>
    );
};

export default Apps;
